"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var jsonCycle_exports = {};
__export(jsonCycle_exports, {
  decycle: () => decycle
});
module.exports = __toCommonJS(jsonCycle_exports);
function decycle(object) {
  const objects = [];
  const paths = [];
  function derez(value, path) {
    let i;
    let name;
    let nu;
    let _value = value;
    try {
      _value = value.toJSON();
    } catch (error) {
    }
    if (typeof _value === "object" && _value) {
      for (i = 0; i < objects.length; i += 1) {
        if (objects[i] === _value) {
          return { $ref: paths[i] };
        }
      }
      objects.push(_value);
      paths.push(path);
      if (Object.prototype.toString.apply(_value) === "[object Array]") {
        const nuArray = [];
        for (i = 0; i < _value.length; i += 1) {
          nuArray[i] = derez(_value[i], path + "[" + i + "]");
        }
        nu = nuArray;
      } else {
        const nuObject = {};
        for (name in _value) {
          if (Object.prototype.hasOwnProperty.call(_value, name)) {
            nuObject[name] = derez(_value[name], path + "[" + JSON.stringify(name) + "]");
          }
        }
        nu = nuObject;
      }
      return nu;
    }
    return _value;
  }
  return derez(object, "$");
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  decycle
});
//# sourceMappingURL=jsonCycle.js.map
